/* eslint-disable no-unused-vars */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../../components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Switch } from '../../components/ui/switch';
import {
  DollarSign, Edit2, Trash2, Save, Plus, RefreshCw, Download, Upload,
  ShoppingCart, MapPin, Building2, Briefcase, Tag, BarChart3, Settings,
  TrendingUp, TrendingDown, CheckCircle, XCircle, AlertTriangle, Eye,
  Globe, Filter, Search, Calculator, Percent, Euro, Target, Layers,
  FileSpreadsheet, FileJson, Copy, Archive, Clock, Users, Activity,
  Recycle, Loader2, Coins
} from 'lucide-react';
import axios from 'axios';
import TypesMaitresManager from '../../components/TypesMaitresManager';
import ReferentielsManager from '../../components/ReferentielsManager';
import { toast } from 'sonner';
import {
  TARIF_TYPES, TERRITOIRES, TYPES_ENTREPRISES, ACTIVITES_PROFESSIONNELLES,
} from '../GestionTarifsDemandesPubliques.constants';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const TerritoiresTab = ({ ctx }) => {
  const {
    activeTab, tarifs, tarifsParTerritoire, tarifsParType, tarifsParEntreprise,
    configParTypeBySpace, activeSpaceTarif, dirtyTypeBySpace, configParEntreprise,
    configParTerritoire, demandes, stats, loading, searchTerm, selectedTerritoire,
    selectedType, selectedStatut, tarifDialogOpen, editingTarif, statsDialogOpen,
    tarifForm, territoiresList, typesEntrepriseList, typesDemandeList, remisesPolitique,
    remisesPolitiqueLoading, viewDialogOpen, viewingDemande, demandeDialogOpen,
    editingDemande, demandeForm, programmees, programmeesLoading, tickNow,
    setActiveTab, setTarifs, setTarifsParTerritoire, setTarifsParType, setTarifsParEntreprise,
    setConfigParTypeBySpace, setActiveSpaceTarif, setDirtyTypeBySpace, setConfigParEntreprise,
    setConfigParTerritoire, setDemandes, setStats, setLoading, setSearchTerm, setSelectedTerritoire,
    setSelectedType, setSelectedStatut, setTarifDialogOpen, setEditingTarif, setStatsDialogOpen,
    setTarifForm, setTerritoiresList, setTypesEntrepriseList, setTypesDemandeList, setRemisesPolitique,
    setRemisesPolitiqueLoading, setViewDialogOpen, setViewingDemande, setDemandeDialogOpen,
    setEditingDemande, setDemandeForm, setProgrammees, setProgrammeesLoading, setTickNow,
    fetchAllData, fetchConfigTerritoires, fetchConfigTypesAllSpaces, fetchDemandes, fetchProgrammees,
    fetchStats, fetchTarifs, filteredDemandes, formatCountdown, getTerritoireInfo, getTypeInfo,
    handleAdminDeleteDemande, handleAdminDuplicateDemande, handleAdminEditDemande, handleCancelSchedule,
    handleCloneFromDefault, handleDeleteTarif, handleDuplicateTarif, handleExport, handlePublishNow,
    handleSaveAdminDemande, handleSaveAllConfigTypeSpace, handleSaveConfigEntreprise,
    handleSaveConfigTerritoire, handleSaveConfigType, handleSaveTarif, handleToggleTarif, handleViewDemande,
    loadReferentielsFromApi, loadRemisesPolitique, openEditDialog, parseActivitesFromDemande,
    resetTarifForm, saveRemisesPolitique, toggleActivite, updateConfigEntreprise, updateConfigTerritoire,
    updateConfigType, SPACES_TARIF, getAuthHeader, emptyTypeConfig,
  } = ctx;
  return (
        <TabsContent value="territoires" className="mt-4 space-y-4">
          <ReferentielsManager
            kind="territoires"
            title="Territoires"
            accentColor="sky"
            onChange={() => loadReferentielsFromApi()}
            extraFields={[
              { key: 'tva', label: 'TVA (%)', type: 'number', step: '0.1', placeholder: '20', metaKey: true },
            ]}
          />
          <Card className="border-0 shadow-lg">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <MapPin className="h-5 w-5 text-blue-600" />
                Configuration par Territoire
              </CardTitle>
              <CardDescription>Ajustez les prix selon le territoire géographique (TVA et coefficients)</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {TERRITOIRES.map(territoire => {
                  const cfg = configParTerritoire[territoire.value] || {};
                  const hidden = cfg.enabled === false;
                  const disabledCR = cfg.disable_coef_remise === true;
                  return (
                  <Card
                    key={territoire.value}
                    className={`border shadow-md hover:shadow-lg transition-all ${hidden ? 'opacity-50 bg-slate-50' : ''}`}
                    data-testid={`territoire-card-${territoire.value}`}
                  >
                    <CardContent className="p-4">
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-2">
                          <Globe className="h-5 w-5 text-blue-600" />
                          <span className="font-bold">{territoire.label}</span>
                          {hidden && (
                            <Badge className="bg-slate-600 text-white text-[10px] font-semibold">MASQUÉ</Badge>
                          )}
                        </div>
                        <Badge className="bg-blue-700 text-white font-semibold">{territoire.tva}% TVA</Badge>
                      </div>
                      <p className="text-sm text-slate-500 mb-3">{territoire.description}</p>

                      {/* Toggles affichage / désactivation coef-remise */}
                      <div className="space-y-1.5 mb-3 p-2 bg-slate-100 rounded-md">
                        <label className="flex items-center justify-between text-xs cursor-pointer">
                          <span className="text-slate-700 font-medium">Afficher ce territoire</span>
                          <input
                            type="checkbox"
                            checked={cfg.enabled !== false}
                            onChange={(e) => updateConfigTerritoire(territoire.value, 'enabled', e.target.checked)}
                            className="w-4 h-4 accent-emerald-600"
                            data-testid={`toggle-enabled-${territoire.value}`}
                          />
                        </label>
                        <label className="flex items-center justify-between text-xs cursor-pointer">
                          <span className="text-slate-700 font-medium">Désactiver coef. &amp; remise</span>
                          <input
                            type="checkbox"
                            checked={cfg.disable_coef_remise === true}
                            onChange={(e) => updateConfigTerritoire(territoire.value, 'disable_coef_remise', e.target.checked)}
                            className="w-4 h-4 accent-amber-600"
                            data-testid={`toggle-disable-cr-${territoire.value}`}
                          />
                        </label>
                      </div>

                      <div className="space-y-2">
                        <div className="flex justify-between items-center text-sm">
                          <span className={`text-slate-600 ${disabledCR ? 'line-through opacity-60' : ''}`}>Coefficient:</span>
                          <Input
                            type="number"
                            step="0.1"
                            value={configParTerritoire[territoire.value]?.coefficient ?? (territoire.value === 'metropole' ? 1.0 : 0.8)}
                            onChange={(e) => updateConfigTerritoire(territoire.value, 'coefficient', e.target.value)}
                            className="w-20 h-7 text-right"
                            disabled={disabledCR || hidden}
                            data-testid={`input-coef-${territoire.value}`}
                          />
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span className={`text-slate-600 ${disabledCR ? 'line-through opacity-60' : ''}`}>Remise spéciale:</span>
                          <Input
                            type="number"
                            step="1"
                            value={configParTerritoire[territoire.value]?.remise_speciale ?? 0}
                            onChange={(e) => updateConfigTerritoire(territoire.value, 'remise_speciale', e.target.value)}
                            className="w-20 h-7 text-right"
                            placeholder="%"
                            disabled={disabledCR || hidden}
                            data-testid={`input-remise-${territoire.value}`}
                          />
                        </div>
                      </div>

                      <Button
                        className="w-full mt-3"
                        variant="outline"
                        size="sm"
                        onClick={() => handleSaveConfigTerritoire(territoire.value)}
                        data-testid={`save-territoire-${territoire.value}`}
                      >
                        <Save className="h-4 w-4 mr-1" /> Enregistrer
                      </Button>
                    </CardContent>
                  </Card>
                  );
                })}
              </div>
            </CardContent>
          </Card>
        </TabsContent>
  );
};

export default TerritoiresTab;
